export const REFERENCE_STORE_REQUIRED_ERROR_CODE = 'error.forecast.reference_store_required'

export interface StoreForecastErrorResponse {
  error_code?: typeof REFERENCE_STORE_REQUIRED_ERROR_CODE
  opening_date?: string
}
